import React from 'react';
import { GlobeIcon, HeartPulseIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-sky-100 bg-white px-4 py-12" data-id="element-210" data-mp="3gfiswe27a3c0">
      <div className="mx-auto max-w-4xl text-center" data-id="element-211" data-mp="32nun0sijob3h">
        <p className="inline-flex items-center gap-2 font-display text-lg font-bold text-primary" data-id="element-212" data-mp="32pfeuadh5fxn">
          <HeartPulseIcon className="h-5 w-5 text-accent" data-id="element-213" data-mp="36pza18ehm9h5" /> COMPRA DIGITAL YA™
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-214" data-mp="3ugbqj7nstejc">
          El sistema N°1 para profesores de educación física, entrenadores personales y personas con
          lesiones en Argentina.
        </p>
        <p className="mt-2 text-sm font-medium text-slate-500" data-id="element-215" data-mp="3ldkeb5n3meqn">
          Porque rehabilitar merece tener un sistema real.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-medium text-slate-600 sm:flex-row sm:gap-6" data-id="element-216" data-mp="3qf9q4ni5awfs">
          <a className="inline-flex items-center gap-1.5 transition-colors hover:text-accent" href="mailto:compradigitayaa@gmail.com" data-id="element-217" data-mp="2eyt9iquuu9rc">
            <MailIcon className="h-4 w-4" data-id="element-218" data-mp="3gagz5ny8f937" /> compradigitayaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors hover:text-accent" href="https://compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-219" data-mp="3gck0v58qyqnr">
            <GlobeIcon className="h-4 w-4" data-id="element-220" data-mp="82qp7jv45dpi" /> compradigitalya.com
          </a>
        </div>
        <p className="mt-7 border-t border-sky-100 pt-6 text-xs font-medium text-slate-400" data-id="element-221" data-mp="3474tnw649z9">
          © Compra Digital Ya™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}